import { ContactInfo } from '@/shared/interfaces/ContactInfo'
import { GroupInfo } from '@/shared/interfaces/GroupInfo'
import { User } from '@/shared/interfaces/User'

export function chatsGetName(chat: {
  user?: User | ContactInfo | null;
  contact?: ContactInfo | null;
  group_info?: GroupInfo | null;
}) {
  if (chat.group_info?.name) {
    return chat.group_info.name
  }

  if (chat.contact?.name) {
    return `${chat.contact.name ?? ''} ${chat.contact.surname ?? ''}`
  }

  if (chat.user?.name) {
    return `${chat.user.name ?? ''} ${chat.user.surname ?? ''}`
  }

  return 'Профиль скрыт'
}
